import store from '../store'

function importLayouts (view) { // Lazy Loading Route
  return (resolve) => import(
    `@/views/layouts/${view}.vue`
  ).then(resolve)
}

function importPages ({ subFolder = null, view }) {
  if (subFolder) {
    return (resolve) => import(
      `@/views/${subFolder}/${view}.vue`
    ).then(resolve)
  }

  return (resolve) => import(
    `@/views/${view}.vue`
  ).then(resolve)
}

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.authorized) {
    next()
    return
  }

  next('/')
}

/* Main layouts */
const mainContainer = importLayouts('AppMain')
const loginContainer = importLayouts('AppLogin')

/* Main views */

const loginView = importPages({ subFolder: 'auth', view: 'Index' })
const permissionView = importPages({ view: 'NoPermission' })

// ----------------------------------------- HOMEPAGE ------------------------------------------------- //
const homeView = importPages({ view: 'Index' })
const profileView = importPages({ subFolder: 'homepage', view: 'Profile' })
const leaveView = importPages({ subFolder: 'homepage', view: 'Leave' })
const payslipView = importPages({ subFolder: 'homepage', view: 'payroll/Payslip' })
const eAFormView = importPages({ subFolder: 'homepage', view: 'payroll/EaForm' })
const letterView = importPages({ subFolder: 'homepage', view: 'payroll/Letter' })
const attendanceView = importPages({ subFolder: 'homepage', view: 'Attendance' })
const claimView = importPages({ subFolder: 'homepage', view: 'Claim' })
const orgChartView = importPages({ subFolder: 'homepage', view: 'OrganizationChart' })

// ----------------------------------------- HRIS ------------------------------------------------- //
const employeeView = importPages({ subFolder: 'hris', view: 'employee/Overview' })
const employeeELetterView = importPages({ subFolder: 'hris', view: 'employee/ELetter' })
const employeeReportView = importPages({ subFolder: 'hris', view: 'employee/EmployeeReport' })

const payrollTransactionView = importPages({ subFolder: 'hris', view: 'payroll/PayrollTransaction' })
const payrollPaymentReportView = importPages({ subFolder: 'hris', view: 'payroll/PayrollPaymentReport' })
const payrollGovernmentReportView = importPages({ subFolder: 'hris', view: 'payroll/PayrollGovernmentReport' })
const payrollTemplateView = importPages({ subFolder: 'hris', view: 'payroll/PayrollTemplate' })
const payrollELetterView = importPages({ subFolder: 'hris', view: 'payroll/ELetter' })
const payrollReportView = importPages({ subFolder: 'hris', view: 'payroll/PayrollReport' })

const leaveDashboardView = importPages({ subFolder: 'hris', view: 'leave/Dashboard' })
const leaveApplyOnBehalfView = importPages({ subFolder: 'hris', view: 'leave/LeaveOnBehalf' })
const leaveApprovalView = importPages({ subFolder: 'hris', view: 'leave/LeaveApproval' })
const leaveReportView = importPages({ subFolder: 'hris', view: 'leave/LeaveReport' })

const claimApprovalView = importPages({ subFolder: 'hris', view: 'claim/ClaimApproval' })
const claimApproveOnBehalfView = importPages({ subFolder: 'hris', view: 'claim/ApproveOnBehalf' })
const claimApplyOnBehalfView = importPages({ subFolder: 'hris', view: 'claim/ApplyOnBehalf' })
const claimBulkpayView = importPages({ subFolder: 'hris', view: 'claim/Bulkpay' })
const claimReportView = importPages({ subFolder: 'hris', view: 'claim/ClaimReport' })

const probationView = importPages({ subFolder: 'hris', view: 'probation/Probation' })
const probationReportView = importPages({ subFolder: 'hris', view: 'probation/ProbationReport' })

const dutyRosterCalendarView = importPages({ subFolder: 'hris', view: 'duty-roster/Calendar' })

const attendanceImportView = importPages({ subFolder: 'hris', view: 'attendance/ImportAndSync' })
const attendanceReportView = importPages({ subFolder: 'hris', view: 'attendance/AttendanceReport' })

const setupClaimView = importPages({ subFolder: 'hris', view: 'setup/Claim' })
const setupCompanyView = importPages({ subFolder: 'hris', view: 'setup/Company' })
const setupDepartmentView = importPages({ subFolder: 'hris', view: 'setup/Department' })
const setupDisciplineView = importPages({ subFolder: 'hris', view: 'setup/Discipline' })
const setupEducationView = importPages({ subFolder: 'hris', view: 'setup/Education' })
const setupHolidayView = importPages({ subFolder: 'hris', view: 'setup/Holiday' })
const setupJobPositionView = importPages({ subFolder: 'hris', view: 'setup/JobPosition' })
const setupLeaveView = importPages({ subFolder: 'hris', view: 'setup/Leave' })
const setupNotificationView = importPages({ subFolder: 'hris', view: 'setup/Notification' })
const setupOfficeLocationView = importPages({ subFolder: 'hris', view: 'setup/OfficeLocation' })
const setupPayrollView = importPages({ subFolder: 'hris', view: 'setup/Payroll' })
const setupRoleView = importPages({ subFolder: 'hris', view: 'setup/Role' })
const setupSeparationView = importPages({ subFolder: 'hris', view: 'setup/Separation' })
const setupWorkSessionView = importPages({ subFolder: 'hris', view: 'setup/WorkSession' })
const setupSystemSettingView = importPages({ subFolder: 'hris', view: 'setup/SystemSetting' })

export default [
  { // catch-all route
    path: '*',
    redirect: {
      path: '/home',
    },
  },
  { // default route
    path: '/',
    redirect: {
      path: '/home',
    },
  },
  {
    path: '/login',
    component: loginContainer,
    beforeEnter: ifNotAuthenticated, // Per-Route Guard
    children: [
      {
        path: '',
        name: 'login',
        component: loginView,
      },
    ],
  },
  {
    path: '',
    component: mainContainer,
    meta: {
      name: '',
      requiresAuth: true,
    },
    children: [
      {
        path: '/permissions/deny',
        name: 'Permission Denied',
        component: permissionView,
        meta: {
          requiresAuth: true,
        },
      },

      /* HOMEPAGE */
      {
        path: '/home',
        name: 'Home',
        component: homeView,
        meta: {
          requiresAuth: true,
        },
      },  
      {
        path: '/profile',
        name: 'Profile',
        component: profileView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-leave',
        name: 'Leave',
        component: leaveView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-payslip',
        name: 'Payslip',
        component: payslipView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-ea',
        name: 'EA Form',
        component: eAFormView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/e-letter',
        name: 'Letter',
        component: letterView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-attendance',
        name: 'Attendance',
        component: attendanceView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-claim',
        name: 'Claim',
        component: claimView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/orgchart',
        name: 'Organization Chart',
        component: orgChartView,
        meta: { 
          requiresAuth: true,
        },
      },

      /* HRIS */
      {
        path: '/employees-hris',
        name: 'Employee Overview',
        component: employeeView,
        meta: { 
          requiresAuth: true,
          permission: 'view hris employees',
          },
      },
      {
        path: '/notification-e-letters',
        name: 'Notification E-Letter',
        component: employeeELetterView,
        meta: {
          requiresAuth: true,
          permission: 'generate e-letters',
        },
      }, 
      {
        path: '/employee-reports',
        name: 'Employee Report',
        component: employeeReportView,
        meta: {
          requiresAuth: true,
          permission: 'view employee reports',
        },
      },
      {
        path: '/payrolls',
        name: 'Payroll Transaction',
        component: payrollTransactionView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll transactions',
        },
      },
      {
        path: '/payroll-payment-reports',
        name: 'Payroll Payment',
        component: payrollPaymentReportView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll payment reports',
        },
      },      
      {
        path: '/payroll-government-reports',
        name: 'Payroll Government',
        component: payrollGovernmentReportView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll government reports',
        },
      },
      {
        path: '/payroll-import',
        name: 'Payroll Template',
        component: payrollTemplateView,
        meta: { 
          requiresAuth: true,
          permission: 'view payroll import',
        },
      },
      {
        path: '/payroll-e-letters',
        name: 'Payroll E-Letter',
        component: payrollELetterView,
        meta: {
          requiresAuth: true,
          permission: 'generate e-letters',
        },
      }, 
      {
        path: '/payroll-reports',
        name: 'Payroll Report',
        component: payrollReportView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll reports',
        },
      },
      {
        path: '/leave-dashboard',
        name: 'Leave Dashboard',
        component: leaveDashboardView,
        meta: { 
          requiresAuth: true,
          permission: 'view leave dashboard',
        },
      },
      {
        path: '/leave-on-behalf',
        name: 'Leave Apply On Behalf',
        component: leaveApplyOnBehalfView,
        meta: { 
          requiresAuth: true,
            permission: 'view leaves on behalf',
          },
      },
      {
        path: '/leave-applications',
        name: 'Leave Approval',
        component: leaveApprovalView,
        meta: { 
          requiresAuth: true,
          permission: 'view leave approvals tab',
        },
      },
      {
        path: '/leave-reports',
        name: 'Leave Report',
        component: leaveReportView,
        meta: {
          requiresAuth: true,
          permission: 'view leave reports',
        },
      },
      {
        path: '/claim-approvals',
        name: 'Claim Approval',
        component: claimApprovalView,
        meta: { 
          requiresAuth: true,
          permission: 'view claim approvals tab',
        },
      },
      {
        path: '/approve-on-behalf',
        name: 'Claim Approve On Behalf',
        component: claimApproveOnBehalfView,
        meta: { 
          requiresAuth: true,
            permission: 'approve claim on behalf',
          },
      },
      {
        path: '/claim-on-behalf',
        name: 'Claim Apply On Behalf',
        component: claimApplyOnBehalfView,
        meta: { 
          requiresAuth: true,
            permission: 'apply claim on behalf',
          },
      },
      {
        path: '/claim-bulkpay',
        name: 'Claim Bulk Pay Report',
        component: claimBulkpayView,
        meta: { 
          requiresAuth: true,
          permission: 'generate claim bulk pay report',
        },
      },
      {
        path: '/claim-report',
        name: 'Claim Report',
        component: claimReportView,
        meta: { 
          requiresAuth: true,
          permission: 'view claim reports',
        },
      },
      {
        path: '/probations',
        name: 'Probation List (New Position)',
        component: probationView,
        meta: { 
          requiresAuth: true,
          permission: 'view probations',
          },
      },
      {
        path: '/probation-reports',
        name: 'Probation Report',
        component: probationReportView,
        meta: {
          requiresAuth: true,
          permission: 'view probation reports',
        },
      },
      {
        path: '/duty-rosters',
        name: 'Duty Roster',
        component: dutyRosterCalendarView,
        meta: { 
          requiresAuth: true,
          permission: 'view duty rosters',
          },
      },
      {
        path: '/attendances',
        name: 'Import Attendance',
        component: attendanceImportView,
        meta: { 
          requiresAuth: true,
            permission: 'view attendance import',
          },
      },
      {
        path: '/attendance-reports',
        name: 'Attendance Report',
        component: attendanceReportView,
        meta: {
          requiresAuth: true,
          permission: 'view attendance reports',  
        },
      },

      /* Setup */
      {
        path: '/claim-setup',
        name: 'Setup Claim',
        component: setupClaimView,
        meta: {
          requiresAuth: true,
          permission: 'view claim setup',
        },
      },
      {
        path: '/companies',
        name: 'Setup Company',
        component: setupCompanyView,
        meta: { 
          requiresAuth: true,
          permission: 'view companies',
          },
      },
      {
        path: '/departments',
        name: 'Setup Department',
        component: setupDepartmentView,
        meta: { 
          requiresAuth: true,
          permission: 'view department section',
        },
      },
      {
        path: '/disciplines',
        name: 'Setup Discipline',
        component: setupDisciplineView,
        meta: { 
          requiresAuth: true,
          permission: 'view discipline setup',
          },
      },
      {
        path: '/education',
        name: 'Setup Education',
        component: setupEducationView,
        meta: {
          requiresAuth: true,
          permission: 'view education',
        },
      },
      {
        path: '/holidays',
        name: 'Setup Holiday',
        component: setupHolidayView,
        meta: {
          requiresAuth: true,
          permission: 'view holiday',
        },
      },
      {
        path: '/job-position',
        name: 'Setup Job Position',
        component: setupJobPositionView,
        meta: {
          requiresAuth: true,
          permission: 'view job position',
        },
      },
      {
        path: '/leave-setup',
        name: 'Setup Leave',
        component: setupLeaveView,
        meta: { 
          requiresAuth: true,
          permission: 'view leave setup',
        },
      },
      {
        path: '/notification-setup',
        name: 'Setup Notification',
        component: setupNotificationView,
        meta: { 
          requiresAuth: true,
          permission: 'view notification types',
        },
      },
      {
        path: '/office-locations',
        name: 'Setup Office Location',
        component: setupOfficeLocationView,
        meta: {
          requireAuth: true,
          permission: 'setup office location view',
        },
      },
      {
        path: '/payroll-setup',
        name: 'Setup Payroll',
        component: setupPayrollView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll',
        },
      },
      {
        path: '/roles',
        name: 'Setup Role',
        component: setupRoleView,
        meta: { 
          requiresAuth: true,
          permission: 'view roles',
        },
      },
      {
        path: '/separation-types',
        name: 'Setup Separation',
        component: setupSeparationView,
        meta: { 
          requiresAuth: true,
          permission: 'view separation types',
        },
      },
      {
        path: '/work-sessions',
        name: 'Setup Work Session',
        component: setupWorkSessionView,
        meta: { 
          requiresAuth: true,
          permission: 'view work session types',
        },
      },
      {
        path: 'system-settings',
        name: 'Setup System Setting',
        component: setupSystemSettingView,
        meta: {
          requireAuth: true,
          permission: 'view system settings',
        },
      },
    ],
  },
]
